import { BEST_SELLERS_PRODUCT_LIST } from '../../../../ahm-constants/ui';
import { BestSellerProductType, BestSellerScaleType, ProductType } from '../../../../types/product';
import { Customer } from '../../../../selectors/select-customer/types';

const isBestSellerScaleType = (
  productType: BestSellerProductType,
  scale: Customer['scale'],
): scale is BestSellerScaleType => Object.hasOwnProperty.call(BEST_SELLERS_PRODUCT_LIST[productType], scale);

const getBestSeller = ({
  productType,
  scale,
}: {
  productType: BestSellerProductType;
  scale: Customer['scale'];
}): ProductType['id'] | null => {
  if (!isBestSellerScaleType(productType, scale)) {
    return null;
  }

  return BEST_SELLERS_PRODUCT_LIST[productType][scale] ?? null; // Null as there may not be a best seller for the given product type
};

export default getBestSeller;
